import { useDataLoading } from "@hooks/loadingHooks";
import { ReduxStore } from "@interfaces/store";
import { userActions } from "@store/user";
import { useSelector } from "react-redux";

export function useGoals() {
    const data = useSelector((store: ReduxStore) => store.user.goals);
    return useDataLoading(userActions.goals.loadGoals, data);
}